import axios from "./httpClient";
import { getApiBaseUrl } from "../data/authStorage";

const baseUrl = getApiBaseUrl();

const ensureBaseUrl = () => {
  if (!baseUrl) {
    throw new Error("REACT_APP_API_BASE_URL is not configured");
  }
  return baseUrl;
};

export const listConflictCases = async ({ status = "All" } = {}) => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/conflicts`, {
    params: { status },
  });
  return response?.data || {};
};

export const getConflictCaseById = async (id) => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/conflicts/${id}`);
  return response?.data || {};
};

export const createConflictCase = async (payload) => {
  const response = await axios.post(`${ensureBaseUrl()}/organizations/conflicts`, payload);
  return response?.data || {};
};

export const updateConflictCase = async (id, payload) => {
  const response = await axios.patch(`${ensureBaseUrl()}/organizations/conflicts/${id}`, payload);
  return response?.data || {};
};

export const addConflictNote = async (id, payload) => {
  const response = await axios.post(`${ensureBaseUrl()}/organizations/conflicts/${id}/notes`, payload);
  return response?.data || {};
};

export const listConflictParticipants = async () => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/conflicts/participants`);
  return response?.data || {};
};
